module.exports = __webpack_public_path__ + "img/seguroautos.4aaab979.jpg";